import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, X } from 'lucide-react';
import { Icon } from '../Icon';

// types
export type ToastType = 'success' | 'failure';

export type ToastProps = {
  message: string;
  type?: ToastType;
  duration: number;
  forceClose: () => void;
};



export function Toast(props: Readonly<ToastProps>): JSX.Element {
  const { message, type = 'success', forceClose, duration } = props;
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  const iconColor = type === 'success' ? 'text-green-500' : 'text-red-500';

  useEffect(() => {
    // Trigger entrance animation
    requestAnimationFrame(() => {
      setIsVisible(true);
    });

    // Set up auto-dismiss
    const timeout = setTimeout(() => {
      handleClose();
    }, duration * 1000);

    return () => clearTimeout(timeout);
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    // Wait for exit animation to complete
    setTimeout(() => {
      forceClose();
    }, 300);
  };

  return (
    <div
      className={`
        fixed top-4 right-4 z-50
        bg-ui_sky_blue border-ui_blue rounded-lg
        p-4 gap-2 flex items-center
        max-w-md shadow-lg
        transition-all duration-300 ease-in-out
        ${isVisible && !isExiting ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
      `}
    >
      <div className="flex items-center gap-2 flex-1">
        <Icon type={type === 'success' ? "success" : 'failure'} className={`w-5 h-5 ${iconColor} flex-shrink-0`} />
        <p className="text-sm font-normal text-ui_blue flex-1">{message}</p>
      </div>
      <button
        onClick={handleClose}
        className="flex-shrink-0 hover:bg-gray-200 rounded p-1 transition-colors"
        aria-label="Close toast"
      >
        <X className="w-4 h-4 text-gray-600" />
      </button>
    </div>
  );
}